import React, {Fragment} from "react";
import styled from "@emotion/styled";
import {css} from "@mui/material";

const Switcher = styled.div<{noMargins?: boolean}>`
	display: flex;
	height: 40px;
	border-radius: 20px;
	--activeColor: #62676e;
	--switcherColor: #30353c;

	background: var(--switcherColor);
	border: 2px solid var(--switcherColor);
	transition: all 0.3s ease;

	${(props) =>
		!props.noMargins &&
		css`
			margin: 0 20px;
		`}
`;

const Button = styled.div<{isActive: boolean}>`
	background: transparent;
	border-radius: 20px;
	height: 100%;
	padding: 10px 0;
	border: none;
	display: flex;
	position: relative;
	transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
	width: 100%;
	min-width: 230px;

	button {
		background: transparent;
		border: none;
		box-shadow: none;
		height: 100%;
		width: 100%;
		flex: 1;
		max-width: 50%;
		display: flex;
		justify-content: center;
		align-items: center;
		&:first-of-type {
			span {
				opacity: ${(props) => (props.isActive ? "1" : "0.5")};
			}
		}
		&:last-of-type {
			span {
				opacity: ${(props) => (!props.isActive ? "1" : "0.5")};
			}
		}
	}
	span {
		color: #ffffff;
		font-weight: 700;
		font-size: 14px;
		display: flex;
		width: 100%;
		white-space: nowrap;
		max-width: 50%;
		opacity: ${(props) => (props.isActive ? "1" : "0.5")};
		position: relative;
		z-index: 1;
		text-align: center;
		justify-content: center;
	}

	&:after {
		position: absolute;
		left: 0;
		top: 0;
		content: "";
		display: block;
		width: 50%;
		border-radius: 20px;
		height: 100%;
		background: var(--activeColor);
		transform: translateX(${(props) => (props.isActive ? "0" : "100%")});
		transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
		transition-delay: 0.1s;
		z-index: 0;
	}
`;

interface IProps {
	options: {label: string; value: string}[];
	value: string;
	onChange: (type: string) => void;
	noMargins?: boolean;
	ariaLabel?: string;
}

export const LeaderboardSwitcher: React.FC<IProps> = ({
	value,
	options,
	onChange,
	noMargins,
	ariaLabel,
}) => {
	const leftValue = options[0].value;
	const rightValue = options[1].value;

	const toggleLeaderboard = () => {
		const newType = value === leftValue ? rightValue : leftValue;
		onChange(newType);
	};

	return (
		<Switcher noMargins={noMargins}>
			<Button
				isActive={leftValue === value}
				role={"tablist"}
				aria-live={"polite"}
				aria-label={ariaLabel}
			>
				{options.map((option) => (
					<Fragment key={option.value}>
						<button
							role={"tab"}
							aria-selected={option.value === value}
							onClick={toggleLeaderboard}
						>
							<span>{option.label}</span>
						</button>
					</Fragment>
				))}
			</Button>
		</Switcher>
	);
};
